<template>
  <div class="credit-cards">
    <h2 class="page-title">熱門信用卡優惠</h2>
    <div class="filters">
      <button class="page-filter-btn" @click="setFilter('全部')" 
        :class="{ active: activeFilter === '全部' }">全部</button>
      <button class="page-filter-btn" @click="setFilter('推薦卡片')"
        :class="{ active: activeFilter === '推薦卡片' }">推薦卡片</button>
      <button class="page-filter-btn" @click="setFilter('時數優惠')"
        :class="{ active: activeFilter === '時數優惠' }">時數優惠</button>

      <!-- <button class="btn-filter">時數優惠</button> -->

    </div>
    <section id="cards" class="cards">
      <!-- Recommend Top 3 Cards -->
      <div v-for="offerCard in filtered_cards" :key="offerCard.id" class="card">
        <div class="card-image-div">
          <div class="card-image-container" >
            <img :src="getOfferCardImageURL(offerCard.id)" :alt="`${offerCard.name} Image`" class="card-image"
              @error="onImageError($event)" 
              @click="gotoCardLink(offerCard.link_url)"
              />
          </div>
        </div>
        <div class="card-content">
          <h3>{{ offerCard.offer }}</h3>
          <p>{{ offerCard.bank + ' | ' + offerCard.name }}</p>
          <!-- <a :href="offerCard.link_url" target="_blank" class="apply-button">Apply</a> -->
          <!-- <button class="add-button" @click="attempAddToRegisteredCard(offerCard)">Add to Registered Cards</button> -->
        </div>
      </div>
    </section>
    <ContactFooter />
  </div>
</template>

<script>
import ContactFooter from '@/components/ContactFooter.vue';
import { mapGetters } from 'vuex';
import { onImageError, getFullImageURL } from '@/util/util';

export default {
  name: 'OfferCards',
  components: {
    ContactFooter,
  },

  data() {
    return {
      activeFilter: '全部',
      filtered_cards: [],
    };
  },
  // Watch for changes in offer_cards
  watch: {
    offer_cards: {
      handler(newVal) {
        this.filtered_cards = newVal;
      },
      deep: true,
    },
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['offer_cards']),
    cardImageMap() {
      // Create a map of offerCardId to card_image
      const map = {};
      this.offer_cards.forEach((card) => {
        map[card.id] = card.card_image;
      });
      return map;
    },
  },
  methods: {
    onImageError,
    getFullImageURL,
    gotoCardLink(link) {
      window.open(link, '_blank');
    },
    getRecommendTop3Cards() {
      const recommendCards = this.offer_cards.filter(
        (card) => card.offer === "推薦卡片"
      );
      // Sort by display_order
      recommendCards.sort((a, b) => a.display_order - b.display_order);
      // return recommendCards.slice(0, 3); // Return top 3 recommended cards
      return this.recommendCards;
    },
    closeModal() {
      this.$emit('close');
    },
    getOfferCardImageURL(offerCardId) {
      const card_image_path = this.cardImageMap[offerCardId];
      if (!card_image_path) {
        return getFullImageURL('/images/placeholder.png');
      }
      return getFullImageURL( card_image_path);
    },
    navigateToOfferCards() {
      this.$router.push('/offer-cards');
    },
    setFilter(filter) {
      this.activeFilter = filter;
      if (filter === '全部') {
        this.filtered_cards = this.offer_cards;
      } else {
        this.filtered_cards = this.offer_cards.filter(
          (card) => card.offer === filter
        );
      }
    },

    // Add additional methods as needed
  },
  mounted() {
    this.filtered_cards = this.offer_cards;
  },
};
</script>

<style scoped>
.credit-cards {
  /* margin-top: 88px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--background-gray);
  /* margin-bottom: 40px; */
}


.filters {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 40px;
  margin-top: 0px;
}

.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* Three columns */
  gap: 24px;
  width: var(--home-component-width);
  justify-content: center;
  margin: 0 auto;

  margin-bottom: 80px;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  box-sizing: border-box;
}

.card-image-div {
  width: 100%;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  align-items: center;
  justify-content: center;
  display: flex;
}

.card-image-container {
  /* width: 300px; */
  width:75%;
  aspect-ratio: 240 / 152;
  /* Maintains the 456x364 aspect ratio */
  overflow: hidden;
  /* Ensures the image doesn't overflow the container */
  border-radius: 20px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 15% auto;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Ensures the image covers the container, cropping as needed */

}

.card-content {
  text-align: center;
  line-height: 1.2rem;
  letter-spacing: 0.05em;
  margin-top: 16px;
  /* Adjusted for spacing */
}

h3 {
  color: var(--green03);
  margin-top: 10px;
  /* Adjusted for spacing */
  letter-spacing: 0.05em;
  font-weight: 700;
}

p {
  color: var(--gray15);
  font-size: 16px;
  font-weight: 400;
  margin-top: 8px;
  letter-spacing: 0.05em;
}

.btn-filter {
  background-color: var(--green03);
  color: white;
  border: none;
  border-radius: 99px;
  padding: 16px 32px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 0px;
}

/* Responsive Styles */
@media (max-width: 800px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
    /* Two columns for medium screens */
  }
}

@media (max-width: 560px) {
  .credit-cards {
    width: 100%;
  }



  .cards {
    grid-template-columns: 1fr;
    /* Single column */
    gap: 32px;
    width: 343px;
    justify-content: center;
    margin: 0 auto;

    margin-bottom: 40px;
  }

  .card {
    width: 100%;
  }

  .card-image-div {
    width: 100%;
    background-color: white;
    border-radius: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  }


  .card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0;
    /* Remove margin adjustments */
  }

  .card-content {
    text-align: center;
    line-height: 1.2rem;
    letter-spacing: 0.05em;
    margin-top: 0;
    padding-top: 0;
  }

  h3 {
    /* color: var(--green03); */
    margin-top: 20px;
    /* letter-spacing: 0.05em; */
    /* font-weight: 700; */
  }

  p {
    /* color: var(--green03); */
    font-size: 16px;
    font-weight: 400;
    margin-top: 20px;
    margin-bottom: 0px;
    letter-spacing: 0.05em;
  }

  .btn-more {
    background-color: var(--green03);
    color: white;
    border: none;
    border-radius: 99px;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    margin-top: 32px;
    margin-bottom: 0px;
  }
}

@media (max-width: 360px) {
  /* Add additional styles if needed */
}
</style>
